"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import HtmlEmbed from "./webflow_modules/Embed/components/HtmlEmbed";

export function CardIconFitness({}) {
  return (
    <Block
      className={"amenity---icon"}
      tag={"div"}
      // @ts-ignore - User-defined custom attribute(s)
      title={"EV Charging"}
    >
      <HtmlEmbed
        className={"html-embed-2"}
        content={
          '<svg viewBox="0 0 13 9" fill="none" xmlns="http://www.w3.org/2000/svg" aria-labelledby="title">\n<title id="title" lang="en">This community has a fitness center.</title>\n<path d="M2.99055 0.453125V8.94445H4.81012V5.30531H8.44925V8.94445H10.2688V0.453125H8.44925V4.09226H4.81012V0.453125H2.99055ZM1.17098 6.51836C1.17098 6.67922 1.23488 6.83349 1.34862 6.94723C1.46237 7.06098 1.61664 7.12488 1.7775 7.12488H2.38402V2.27269H1.7775C1.61664 2.27269 1.46237 2.3366 1.34862 2.45034C1.23488 2.56409 1.17098 2.71836 1.17098 2.87922V4.09226H0.564453V5.30531H1.17098V6.51836ZM12.0884 2.87922C12.0884 2.71836 12.0245 2.56409 11.9107 2.45034C11.797 2.3366 11.6427 2.27269 11.4819 2.27269H10.8753V7.12488H11.4819C11.6427 7.12488 11.797 7.06098 11.9107 6.94723C12.0245 6.83349 12.0884 6.67922 12.0884 6.51836V5.30531H12.6949V4.09226H12.0884V2.87922Z" fill="currentColor"/>\n</svg>'
        }
      />
    </Block>
  );
}
